import React, {Component} from 'react';
import SideMenu from '../admin/SideMenu';
import TopMenu from '../admin/TopBar';
import '../../styles/css/AdminMain.css';
import {appDatabasePrimaryFunctions, base} from "../../base";
import {ErrorMessage, Toast, WarningMessage} from "../utils/HelpfulFunction";
import {summariseSend} from "../utils/sendSummary";
import {runInBatches} from "../utils/batch";
import {sendOneReward, collectOutcomes} from "../utils/rewardSend";

class SendRewards extends Component {
    constructor(props) {
        super(props);
        this.state = {
            sendProgress: null,
            rewardsList: [],
            userCheckedInCount: [],
            loading: true
        };
        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {
      this.getRewards();
      this.userCheckedInCountRef = base.listenTo('userCheckedIn', {
          context: this,
          queries: {
              orderByChild: 'checkedIn',
              equalTo: true
          },
          asArray: true,
          then(userCheckedInArray){
              this.setState({userCheckedInArray: userCheckedInArray})
          }
      })
    }

    componentWillUnmount() {
        base.removeBinding(this.userCheckedInCountRef);
    }

    getRewards(){
        const urlToGet = process.env.REACT_APP_REWARD_URL + 'coupons';
        fetch(urlToGet)
            .then(response => response.json())
            .then(data => {
                this.setState({
                    loading: false,
                    rewardsList: data.data || []
                })
            })
            .catch(e => {
                console.log("ERROR", e)
                this.setState({loading: false})
            })
    }

    handleChange(event){
      this.setState({[event.target.name]: event.target.value});
    }

    async sendRewards(){
        let selectedReward = false;
        const rewardsList = this.state.rewardsList || [];
        const rewardToSend = this.state.rewardToSend || 0;
        const userCheckedInArray = this.state.userCheckedInArray || [];
        for(const rewardIndex in rewardsList){
            const reward = rewardsList[rewardIndex];
            if(parseInt(reward.id) === parseInt(rewardToSend)){
                selectedReward = reward
            }
        }
        if(!rewardToSend || !selectedReward){
            await ErrorMessage.fire({
                title: 'Uh oh!',
                text: 'Select a reward to send'
            })
            return;
        }
        if(selectedReward.unique_codes.length > 0){
            await ErrorMessage.fire({
                title: 'Uh oh!',
                text: 'At this time unique codes rewards are not supported'
            })
            return;
        }
        if(userCheckedInArray.length < 1){
            await ErrorMessage.fire({
                title: 'Uh oh!',
                text: 'No One Checked In Yet'
            })
            return
        }
        if(parseInt(selectedReward.number_available) < userCheckedInArray.length){
            const warningResponse = await WarningMessage.fire({
                title: 'Warning!',
                text: 'Less reward amount then people checked in, proceed?',
                confirmButtonText: 'Yes'
            });
            if(!warningResponse.value){
                return
            }
        }
        const sendPrizesResponse = await WarningMessage.fire({
            title: 'Send this reward?',
            text: 'Are you sure? This will send an email to all fans checked in with this reward!',
            confirmButtonText: 'Yes'
        });
        if(!sendPrizesResponse.value){
            return
        }
        this.setState({loading: true});
        const emails = [];
        const users = [];
        const usersRef = await appDatabasePrimaryFunctions.ref('users').once('value');
        const couponEmailRef = await appDatabasePrimaryFunctions.ref('couponEmail').once('value');
        const uidToUsernameRef = await appDatabasePrimaryFunctions.ref('uidToUsername').once('value');
        const usernameToEmailRef = await appDatabasePrimaryFunctions.ref('usernameToEmail').once('value');
        const usersObject = usersRef.val();
        const couponEmailObject = couponEmailRef.val();
        const uidToUsernameObject = uidToUsernameRef.val();
        const usernameToEmailObject = usernameToEmailRef.val();
        for(let i = 0; i < userCheckedInArray.length; i++){
            const user = {};
            const userId = userCheckedInArray[i].key;
            user['userId'] = userId;
            let userObject = usersObject[userId] || {};
            let userEmail = userObject.email || "";
            if(!userEmail && couponEmailObject[userId]){
                userEmail = couponEmailObject[userId].email || "";
            }
            if(uidToUsernameObject[userId]){
                const username = uidToUsernameObject[userId].userName || "";
                user['username'] = username;
                if(username && usernameToEmailObject[username] && usernameToEmailObject[username].email && !userEmail){
                    userEmail = usernameToEmailObject[username].email;
                }
            }
            if(userEmail && emails.indexOf(userEmail) === -1){
                emails.push(userEmail)
                user['email'] = userEmail;
                users.push(user)
            }
        }
        const withoutEmail = userCheckedInArray.length - users.length;
        if(emails.length > 0){
            await this.sendEmails(users, selectedReward, withoutEmail);
        } else {
            // Nothing was sent, and saying 'Emails sent' here was simply untrue.
            this.setState({loading: false});
            const summary = summariseSend([], withoutEmail);
            ErrorMessage.fire({ title: summary.title, text: summary.text });
        }
    }

    // Every send is waited on and counted. This used to fire the requests
    // without awaiting them and then announce 'Emails sent' regardless — so a
    // send that failed for every fan reported success, on the one screen whose
    // own warning says it cannot be undone.
    async sendEmails(users, reward, withoutEmail = 0){
        // A chunk at a time, so a full house does not arrive at the reward
        // service as one burst — and so the operator can see it moving.
        const { results, failures } = await runInBatches(
            users,
            user => this.redeemCoupon(user, reward),
            { onProgress: (done, total) => this.setState({ sendProgress: { done, total } }) }
        );
        this.setState({loading: false, sendProgress: null});

        // A worker that threw outright still belongs in the count, or the
        // summary would quietly report on fewer fans than were attempted.
        const attempted = collectOutcomes(results, failures);

        attempted.filter(r => !r.ok).forEach(f =>
            console.error('[sendRewards] failed for', f.email, f.error));

        const summary = summariseSend(attempted, withoutEmail);
        if (summary.kind === 'success') {
            Toast.fire({ title: summary.title });
            return;
        }
        const dialog = summary.kind === 'error' ? ErrorMessage : WarningMessage;
        dialog.fire({
            title: summary.title,
            text: summary.text,
            confirmButtonText: 'OK',
            showCancelButton: false
        });
    }

    async redeemCoupon(user, reward){
        return sendOneReward(user, reward, {
            url: process.env.REACT_APP_REWARD_URL + 'redeemed_coupons/admin_coupon_giveaway'
        });
    }

    render() {
        const userCheckedInCount = this.state.userCheckedInArray || [];
        return (
          <div className="admin-wrapper">
            <div className="loading-screen" style={{display: this.state.loading ? 'block' : 'none' }}/>
            <SideMenu/>
            <TopMenu/>
            <div className="admin-main-panel">
                <div className="admin-page-head">
                    <p className="admin-eyebrow">Fan engagement</p>
                    <p className="admin-header-text">Send Rewards</p>
                    <p className="admin-page-sub">
                        Send a reward straight to fans by email. This goes out immediately and cannot be undone.
                    </p>
                </div>
                <div className="container sidebar-container">
                    <div className="col-md-12">
                        {/* this list is the only thing standing between an operator and
                            an un-recallable email, so it reads as a warning, not an <ol> */}
                        <div className="admin-callout is-warn">
                            <p className="admin-callout-title">Before you send</p>
                            <ul>
                                <li>Only use this for rewards that are not being handed out any other way.</li>
                                <li>The reward you send <b>cannot</b> have codes.</li>
                                <li>Fans who checked in without an email will not receive it.</li>
                                <li>Make sure enough of the reward is left — if there is not, fans get nothing.</li>
                            </ul>
                        </div>
                        {/* the nav, the label and the button each called this a
                            different thing; unified on "reward", which is what the data model calls it */}
                        <div className="admin-form-box" style={{margin: 0, maxWidth: 560}}>
                            <div className="form-group">
                                <label htmlFor="rewardToSend">Reward</label>
                                <p className="admin-hint">Only rewards without codes can be sent this way.</p>
                                <select name="rewardToSend" id="rewardToSend" className="form-control" onChange={this.handleChange}>
                                    <option value="">Select a reward&hellip;</option>
                                    {this.state.rewardsList.length > 0 &&
                                        <>
                                            {
                                                this.state.rewardsList.map(function(item, index) {
                                                    return(
                                                        <option value={item.id} key={index}>{item.name}</option>
                                                    )
                                                })
                                            }
                                        </>
                                    }
                                </select>
                            </div>

                            <div className="admin-statcard" style={{marginBottom: 4}}>
                                <p className="admin-eyebrow">Fans checked in</p>
                                <p className="admin-statcard-value">{userCheckedInCount.length}</p>
                                <p className="admin-statcard-sub">Everyone with an email on file will receive the reward.</p>
                            </div>

                            <div className="admin-actions">
                                <button
                                    className="btn btn-primary"
                                    disabled={!!this.state.sendProgress}
                                    onClick={()=>this.sendRewards()}
                                >
                                    Send reward to {userCheckedInCount.length} {userCheckedInCount.length === 1 ? 'fan' : 'fans'}
                                </button>
                                {/* Sending to a full house is a long wait with nothing
                                    on screen otherwise, and no way to tell a slow send
                                    from a stuck one. */}
                                {this.state.sendProgress &&
                                    <span className="admin-send-progress">
                                        Sending&hellip; {this.state.sendProgress.done} of {this.state.sendProgress.total}
                                    </span>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
         </div>
        );
    }
}

export default SendRewards
